import React from "react";

/** Value can be a string (displayed as-is) or { label: string } for custom link text */
type ButtonLinkValue = string | { label: string };

interface ButtonLinkCellProps {
  value: ButtonLinkValue;
  onReviewClick?: () => void;
  [key: string]: any;
}

const getDisplayText = (value: ButtonLinkValue): string => {
  if (value === undefined || value === null) return "";
  if (typeof value === "object" && "label" in value)
    return String(value.label ?? "");
  return String(value);
};

export const ButtonLinkCell: React.FC<ButtonLinkCellProps> = ({
  value,
  onReviewClick,
}) => {
  const handleReviewClick = () => {
    if (onReviewClick) {
      onReviewClick();
    }
  };

  return (
    <>
      <button
        className="table-cell-btn__link w-full"
        onClick={handleReviewClick}
      >
        <div className="button-text truncate">{getDisplayText(value)}</div>
      </button>
    </>
  );
};

export default ButtonLinkCell;
